import { Grid } from "@material-ui/core";
import React from "react";
import { BooleanInput } from "react-admin";

const DaysOfWeekInput = () => (
  <>
    <Grid item xs={2}>
      <BooleanInput label="Monday" source="isCcaMonday" defaultValue={true} />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Tuesday" source="isCcaTuesday" defaultValue={true} />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput
        label="Wednesday"
        source="isCcaWednesday"
        defaultValue={true}
      />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput
        label="Thursday"
        source="isCcaThursday"
        defaultValue={true}
      />
    </Grid>

    <Grid item xs={2}>
      <BooleanInput label="Friday" source="isCcaFriday" defaultValue={true} />
    </Grid>
  </>
);

export default DaysOfWeekInput;
